import SkeletonLoader from './skeleton-loader';
import React from 'react';

const getSkeletonCards = (
  quantity: number,
  props: any,
  wrapperClassName?: string,
) => {
  const cards = [];
  for (let i = 0; i < quantity; i++) {
    const skeletonLoader = (
      <SkeletonLoader key={`skeleton-loader-${i}`} {...props} />
    );

    if (wrapperClassName) {
      cards.push(
        <div key={`skeleton-card-${i}`} className={wrapperClassName}>
          {skeletonLoader}
        </div>,
      );
    } else {
      cards.push(skeletonLoader);
    }
  }
  return cards;
};

export default getSkeletonCards;
